$(document).ready(function() {
    // sort all home designs into memory
    const homeDesignContainer = document.getElementById('home-design-container');
    const displayHomesContainer = document.getElementById('display-homes-container');
    const financeContainer = document.getElementById('finance-container');
    const houseAndLandContainer = document.getElementById('house-and-land-container');
    const suburbContainer = document.getElementById('suburb-container');
    const loadMoreSuburbs = document.getElementById('load-more-suburbs');

    const filterableContainer = homeDesignContainer || houseAndLandContainer;
    if (filterableContainer) {
        const loadMorebutton = document.querySelectorAll('#load-more-home-designs, #load-more-display-homes')[0] || null;
        const filterResultsMsg = document.querySelectorAll('#filter-home-designs-results, #filter-display-homes-results')[0] || null;
        const mobileFilterSubmit = document.getElementById('home-design-mobile-filter-submit');
        const filterableDesignCards = [];

        const initFilters = function() {
            // Adjusting CSS on load as slick slider breaks if you set position before it is loaded
            var filterEntries,
                filterIndex,
                selElementIndex,
                filterEntriesLen,
                selElmntLen,
                selElmnt,
                selectedItemEle,
                optionListEle,
                optionItem;
            /* Look for any elements with the class "custom-select": */
            filterEntries = document.getElementsByClassName('hd-filter-entry');
            filterEntriesLen = filterEntries.length;
            for (filterIndex = 0; filterIndex < filterEntriesLen; filterIndex++) {
                selElmnt = filterEntries[filterIndex].getElementsByTagName('select')[0];
                selElmntLen = selElmnt.length;

                let isMobile = !!selElmnt.closest('.hd-filter-mobile') || !!selElmnt.closest('.hl-filter-mobile');

                /* For each element, create a new DIV that will act as the selected item: */
                selectedItemEle = document.createElement('DIV');
                selectedItemEle.setAttribute('class', 'select-selected');
                selectedItemEle.innerHTML =
                    selElmnt.options[selElmnt.selectedIndex] === undefined
                        ? 'Any'
                        : selElmnt.options[selElmnt.selectedIndex].innerHTML;
                filterEntries[filterIndex].appendChild(selectedItemEle);
                /* For each element, create a new DIV that will contain the option list: */
                optionListEle = document.createElement('DIV');
                optionListEle.setAttribute('class', 'select-items select-hide');
                optionListEle.setAttribute('data-for', selElmnt.getAttribute('data-for'));

                for (selElementIndex = 1; selElementIndex < selElmntLen; selElementIndex++) {
                    /* For each option in the original select element,
                    create a new DIV that will act as an option item: */
                    optionItem = document.createElement('DIV');
                    optionItem.innerHTML = selElmnt.options[selElementIndex].innerHTML;
                    optionItem.setAttribute('data-for', selElmnt.getAttribute('data-for'));
                    optionItem.setAttribute('data-val', optionItem.innerHTML);
                    optionItem.setAttribute('data-default', selElmnt.options[selElementIndex].selected);

                    // Copy all data- attributes into our cloned element
                    const dataVals = $(selElmnt.options[selElementIndex]).data();
                    for (let key in dataVals) {
                        optionItem.setAttribute(`data-${key}`, dataVals[key]);
                    }

                    optionItem.addEventListener('click', function(e) {
                        updateItemClick(this, true);
                        updateDisplayedCards();
                    });
                    optionListEle.appendChild(optionItem);
                }
                filterEntries[filterIndex].appendChild(optionListEle);
                selectedItemEle.setAttribute('data-mobile', isMobile);

                for (let optionEle of optionListEle.children) {
                    if (optionEle.getAttribute('data-default') === 'true') {
                        updateItemClick(optionEle);
                    }
                }

                selectedItemEle.addEventListener('click', function(e) {
                    e.stopImmediatePropagation();
                    let openSelEle = this.nextElementSibling;

                    document.querySelectorAll('.hd-filter-entries div.select-items').forEach(ele => {
                        if (ele === openSelEle) {
                            ele.classList.toggle('select-hide');
                        } else {
                            ele.classList.add('select-hide');
                        }
                    });

                    document.querySelectorAll('.hd-filter-entry-multiselect .hd-filter-checkboxes').forEach(ele => {
                        ele.classList.add('select-hide');
                    });
                });
            }

            document.addEventListener('click', closeAllSelect);
            $('#hd-filter-mobile .hd-filter-checkboxes').removeAttr('id');
            $('.hd-filter-entry-multiselect .select-box').on('click', event => {
                event.currentTarget.nextElementSibling.classList.toggle('select-hide');
                document.querySelectorAll('.hd-filter-entries div.select-items').forEach(ele => {
                    ele.classList.add('select-hide');
                });
            });

            document.querySelectorAll('.hd-filter-entry-multiselect').forEach(item => {
                item.setAttribute('data-mobile', !!item.closest('.hd-filter-mobile'));
            });

            const checkboxes = document.querySelectorAll(`.hd-filter-entry-multiselect input[type="checkbox"]`);

            checkboxes.forEach(cb => {
                const isMobile = !!cb.closest('.hd-filter-mobile');
                cb.setAttribute('data-mobile', isMobile);
                cb.checked = false;

                cb.addEventListener('change', e => {
                    const container = e.target.closest('.hd-filter-entry-multiselect');
                    const labelEle = container.querySelector('div.select-selected');
                    const checkedFeatures = container.querySelectorAll('input[type="checkbox"]:checked').length;

                    labelEle.innerText = !checkedFeatures ? 'Any' : `${checkedFeatures} Selected`;
                });

                if (!isMobile) {
                    cb.addEventListener('change', e => {
                        updateDisplayedCards();
                    });
                }
            });

            if (mobileFilterSubmit) {
                mobileFilterSubmit.addEventListener('click', () => {
                    updateFilterSelections(false);

                    updateDisplayedCards();
                    const modal = UIkit.modal('#hd-filter-mobile') || UIkit.modal('#hl-filter-mobile') || UIkit.modal('#tw-filter-mobile');
                    modal.hide();
                });
            }

            const clearButtons = document.querySelectorAll('.hd-filter-clear > button');
            clearButtons.forEach((button) => {
                button.addEventListener('click', clearFilters);
            });
        };

        const initForMobile = window.matchMedia('only screen and (max-width: 640px)').matches;
        const cardDefaults = {
            '/house-and-land/': {
                mobile: {
                    defaultCount: 6,
                    showMoreCount: 9
                },
                desktop: {
                    defaultCount: 9,
                    showMoreCount: 9
                }
            },
            default: {
                mobile: {
                    defaultCount: 12,
                    showMoreCount: 12
                },
                desktop: {
                    defaultCount: 12,
                    showMoreCount: 12
                }
            },
        };

        const defaultCounts = (cardDefaults[window.location.pathname] || cardDefaults.default)[initForMobile ? 'mobile' : 'desktop'];
        const defaultCardCount = defaultCounts.defaultCount;
        const showMoreCardCount = defaultCounts.showMoreCount;
        let maxCardsShown = defaultCardCount;

        const clearFilters = (event) => {
            const isMobile = !!event.target.closest('.hd-filter-mobile') || !!event.target.closest('.hl-filter-mobile');

            // reset the selects back to the first (default) value
            document.querySelectorAll(
                    `.hd-filter-entry:not(.sort) div[data-mobile='${isMobile}'] + div.select-items > :first-child`
            ).forEach((option) => option.click());

            // reset the feature checkboxes
            document.querySelectorAll(
                `.hd-filter-checkboxes input[data-mobile='${isMobile}'][type='checkbox']:checked`
            ).forEach((checkbox) => checkbox.click());

            if (isMobile) {
                updateFilterSelections(false);
                updateDisplayedCards();
            }
        };

        const initCards = function() {
            if (filterableContainer) {
                while (filterableContainer.children.length) {
                    const ele = filterableContainer.children[0];

                    filterableDesignCards.push({
                        element: ele,
                        filters: {
                            Bedrooms: parseInt(ele.getAttribute('data-bedrooms')),
                            Bathrooms: parseInt(ele.getAttribute('data-bathrooms')),
                            Storeys: parseInt(ele.getAttribute('data-storeys')),
                            SuburbTitle: ele.getAttribute('data-suburbtitle'),
                            Price: parseInt(ele.getAttribute('data-price')),
                            BlockWidth: parseFloat(ele.getAttribute('data-blockwidth')),
                            Features: (ele.getAttribute('data-features') || '').split(',').filter(item => item.length)
                        },
                        sortBy: {
                            Price: parseInt(ele.getAttribute('data-price')),
                            Title: ele.getAttribute('data-title'),
                            Created: ele.getAttribute('data-created'),
                            Popular: ele.getAttribute('data-popular')
                        }
                    });

                    ele.parentElement.removeChild(ele);
                }

                for (let i = 0; i < maxCardsShown; i++) {
                    const filterableCard = filterableDesignCards[i] || null;
                    if (filterableCard) {
                        filterableContainer.appendChild(filterableCard.element);
                    }
                }
            }
        };

        const filteredHomeDesignCards = function() {
            let isAnyFilterSet = false;

            let filters = {
                Bedrooms: null,
                Bathrooms: null,
                BlockWidth: null,
                Storeys: null,
                SuburbTitle: null,
                PriceRange: null
            };

            // regular single-selection filters
            for (let key in filters) {
                const filterEle = document.querySelector(`.hd-filter-entry div[data-mobile='false'] + div.select-items > div[data-for="${key}"].same-as-selected`);

                if (filterEle) {
                    const dataVal = filterEle.getAttribute('data-val');

                    if (dataVal === 'Any') {
                        filters[key] = null;
                    } else {
                        switch (key) {
                            case 'PriceRange':
                                filters[key] = [filterEle.getAttribute('data-min'), filterEle.getAttribute('data-max')];
                                break;

                            default:
                                filters[key] = dataVal;
                                break;
                        }

                        isAnyFilterSet = true;
                    }
                }
            }

            // features.. multiselect filter
            filters.Features = [
                ...document.querySelectorAll(
                    `.hd-filter-entry-multiselect input[type="checkbox"][data-mobile='false']:checked`
                )
            ].map(item => item.getAttribute('data-id'));
            isAnyFilterSet = isAnyFilterSet || !!filters.Features.length;

            let filteredDesigns = filterableDesignCards.filter(designCard => {
                if (filters.Bedrooms && designCard.filters.Bedrooms != filters.Bedrooms) {
                    return false;
                }

                if (filters.Bathrooms && designCard.filters.Bathrooms != filters.Bathrooms) {
                    return false;
                }

                if (filters.BlockWidth) {
                    switch (filters.BlockWidth) {
                        case 'Less than 12.5M':
                            if (!(designCard.filters.BlockWidth < 12.5)) {
                                return false;
                            }
                            break;

                        case '12.5M to 15M':
                            if (!(12.5 <= designCard.filters.BlockWidth && designCard.filters.BlockWidth <= 15)) {
                                return false;
                            }
                            break;

                        case 'More than 15M':
                            if (!(designCard.filters.BlockWidth > 15)) {
                                return false;
                            }
                            break;
                    }
                }

                if (filters.Storeys) {
                    const storeyOptions = ['single storey', 'double storey'];

                    let numericStoreys = storeyOptions.indexOf(filters.Storeys.toLowerCase()) + 1;
                    if (numericStoreys !== designCard.filters.Storeys) {
                        return false;
                    }
                }

                if (filters.PriceRange) {
                    const minPrice = filters.PriceRange[0];
                    const maxPrice = filters.PriceRange[1];

                    if (designCard.filters.Price < minPrice || designCard.filters.Price > maxPrice) {
                        return false;
                    }
                }

                if (filters.Features.length) {
                    const designFeatures = designCard.filters.Features;

                    if (!designFeatures.length) {
                        return false;
                    }

                    for (let feature of filters.Features) {
                        if (designFeatures.indexOf(feature) === -1) {
                            return false;
                        }
                    }
                }

                if (filters.SuburbTitle && designCard.filters.SuburbTitle != filters.SuburbTitle) {
                    return false;
                }

                return true;
            });

            const plural = filteredDesigns.length > 1 ? 's' : '';
            const plural2 = filteredDesigns.length === 1 ? 'es' : '';

            const dataWording = filterResultsMsg.getAttribute('data-wording');
            const wording = dataWording + plural;

            let message = filteredDesigns.length
                ? `Explore ${filteredDesigns.length} ${wording}`
                : 'No results found';
            let suffix = isAnyFilterSet ? ` that match${plural2} your criteria` : '';

            filterResultsMsg.innerText = message + suffix;

            let sortValue = dataWording === 'House and Land Package' ? 'Price Low - High' : 'Most Popular';
            let sortElement = document.querySelector(
                `.hd-filter-entry.sort div[data-mobile='false'] + div.select-items > div[data-for="Sort"].same-as-selected`
            );

            if (sortElement) {
                sortValue = sortElement.getAttribute('data-val');
            }

            switch (sortValue) {
                case 'Most Popular':
                    filteredDesigns.sort(function(a, b) {
                        return a.sortBy.Popular - b.sortBy.Popular;
                    });
                    break;

                case 'Price Low - High':
                    filteredDesigns.sort(function(a, b) {
                        return a.sortBy.Price - b.sortBy.Price;
                    });
                    break;

                case 'Price High - Low':
                    filteredDesigns.sort(function(a, b) {
                        return b.sortBy.Price - a.sortBy.Price;
                    });
                    break;

                case 'A - Z':
                    filteredDesigns.sort(function(a, b) {
                        return a.sortBy.Title.localeCompare(b.sortBy.Title);
                    });
                    break;

                case 'Z - A':
                    filteredDesigns.sort(function(a, b) {
                        return b.sortBy.Title.localeCompare(a.sortBy.Title);
                    });
                    break;

                case 'Recently Added':
                    filteredDesigns.sort(function(a, b) {
                        return b.sortBy.Created - a.sortBy.Created;
                    });
                    break;
            }

            return filteredDesigns;
        };

        const updateDisplayedCards = function() {
            const displayDesigns = filteredHomeDesignCards();
            let displayCounter = 0;

            filterableContainer.innerHTML = null;

            for (let designCard of displayDesigns) {
                if (displayCounter < maxCardsShown) {
                    filterableContainer.appendChild(designCard.element);
                    displayCounter++;
                }
            }

            if (loadMorebutton) {
                if (displayDesigns.length <= maxCardsShown) {
                    loadMorebutton.classList.add('uk-hidden');
                }
                else {
                    loadMorebutton.classList.remove('uk-hidden');
                }
            }
        };

        const updateItemClick = function(optionItem, doClick = false) {
            const selectElement = optionItem.parentNode.parentNode.getElementsByTagName('select')[0];

            const selectElementLen = selectElement.options.length;
            const previousSibling = optionItem.parentNode.previousSibling;

            for (let i = 0; i < selectElementLen; i++) {
                if (selectElement.options[i].innerHTML === optionItem.innerHTML) {
                    selectElement.selectedIndex = i;
                    previousSibling.innerHTML = optionItem.innerHTML;
                    const sameAsSelected = optionItem.parentNode.getElementsByClassName('same-as-selected');
                    const sameAsSelectedLen = sameAsSelected.length;
                    for (let sameAsSelectedIndex = 0; sameAsSelectedIndex < sameAsSelectedLen; sameAsSelectedIndex++) {
                        sameAsSelected[sameAsSelectedIndex].removeAttribute('class');
                    }
                    optionItem.setAttribute('class', 'same-as-selected');
                    break;
                }
            }

            if (doClick) {
                previousSibling.click();
            }
        };

        // Copy filter selections from Mobile to desktop or vice-versa
        const updateFilterSelections = function(toModal = true) {
            // select boxes
            const selectedOptions = document.querySelectorAll(
                `.hd-filter-entry div[data-mobile='${!toModal}'] + div.select-items > .same-as-selected`
            );

            for (let selected of selectedOptions) {
                const selectedOption = document.querySelector(
                    `.hd-filter-entry div[data-mobile='${toModal}'] + div.select-items > div[data-for="${selected.getAttribute(
                        'data-for'
                    )}"][data-val="${selected.getAttribute('data-val')}"]`
                );
                updateItemClick(selectedOption, false);
            }

            const sourceCheckboxes = document.querySelectorAll(
                `.hd-filter-entry-multiselect input[type="checkbox"][data-mobile='${!toModal}']`
            );

            let checkedFeatures = 0;
            for (let sourceCheckbox of sourceCheckboxes) {
                const destCheckbox = document.querySelector(
                    `.hd-filter-entry-multiselect input[type="checkbox"][data-mobile='${toModal}'][data-id="${sourceCheckbox.getAttribute(
                        'data-id'
                    )}"]`
                );
                destCheckbox.checked = sourceCheckbox.checked;
                checkedFeatures += destCheckbox.checked ? 1 : 0;
            }

            const featureContainer = document.querySelector(`.hd-filter-entry-multiselect[data-mobile="${toModal}"]`);
            if (featureContainer) {
                const labelEle = featureContainer.querySelector('div.select-selected');

                labelEle.innerText = !checkedFeatures ? 'Any' : `${checkedFeatures} Selected`;
            }
        };

        const closeAllSelect = function(event) {
            if (event.target.classList.contains('select-selected') || event.target.closest('.hd-filter-checkboxes')) {
                return;
            }
            event.stopPropagation();

            document
                .querySelectorAll(
                    '.hd-filter-entries div.select-items, .hd-filter-entry-multiselect .hd-filter-checkboxes'
                )
                .forEach(ele => {
                    ele.classList.add('select-hide');
                });
        };

        if (loadMorebutton) {
            loadMorebutton.addEventListener('click', () => {
                maxCardsShown += showMoreCardCount;
                updateDisplayedCards();
            });
        }

        $('#hd-filter-mobile, #hl-filter-mobile').on('show.uk.modal', () => {
            updateFilterSelections(true);
        });

        initFilters();
        initCards();
        updateDisplayedCards();
    }

    if (displayHomesContainer) {
        // Show more button for Display Homes Page
        var sliceSize = 6;

        if ($(window).width() < 640) {
            sliceSize = 6;
        } else {
            sliceSize = 100;
        }

        $( window ).resize(function() {
            if ($(window).width() < 640) {
                sliceSize = 6;
                $('.display-homes-card').slice(0, sliceSize).show();
            } else {
                sliceSize = 100;
                $('.display-homes-card').slice(0, sliceSize).show();
            }
        })

        $(function () {
            $('.display-homes-card').slice(0, sliceSize).show();
            $('#load-more-display-homes').on('click', function (e) {
                e.preventDefault();
                $('.display-homes-card:hidden').slice(0, sliceSize).slideDown();
                if ($('.display-homes-card:hidden').length == 0) {
                    $('#load-more-display-homes').fadeOut('slow');
                }
            });
        });
    }

    if (suburbContainer && loadMoreSuburbs) {
        const defaultSuburbsShown = 6;
        let loadableSuburbs = [];

        const initSuburbs = function() {
            // suburb enquire buttons
            document.querySelectorAll(`.suburb-card > a`).forEach((suburbAnchor) => {
                suburbAnchor.addEventListener('click', () => {
                    const suburbInput = document.querySelector(`.contact-form form input[name="SuburbTitle"]`);
                    if (suburbInput) {
                        suburbInput.value = suburbAnchor.getAttribute('data-val');
                    }
                });
            });

            while (suburbContainer.children.length > defaultSuburbsShown) {
                const ele = suburbContainer.children[defaultSuburbsShown];

                loadableSuburbs.push(ele);

                ele.parentElement.removeChild(ele);
            }
        };
        initSuburbs();
        if (!loadableSuburbs.length) {
            loadMoreSuburbs.classList.add('uk-hidden');
        } else {
            loadMoreSuburbs.addEventListener('click', () => {
                for (let suburb of loadableSuburbs) {
                    suburbContainer.appendChild(suburb);
                }

                loadableSuburbs = [];
                loadMoreSuburbs.classList.add('uk-hidden');
            });
        }
    }
});
